 <div (window:resize)="commonService.resize()">



  <app-header></app-header>

  <router-outlet></router-outlet>

  <app-footer></app-footer>
  <app-cookies></app-cookies>
  <div (click)="toggleSideMenu()" *ngIf="commonService.showShadow"  class="app__shadow"></div>
 </div>
